<template>
  <div class="container">
    <div class="form-row">
      <h3 class="form-group col-sm-5">Gestion des tâches régulières</h3>
      <div class="form-group col-sm-7 d-flex justify-content-end">
        <button type="button" class="btn btn-default btn-sm" @click="show=!show">+</button>
      </div>
    </div>
    <section>
      <div v-show="show">
        <hr>
        <div class="form-row">
          <div class="form-group col-sm-3">
            <kez-select
              :label="'Type'"
              v-model="regularTask.typeGuid"
              :options="formattedRegularTaskTypes"
              validate="required"
            />
          </div>
          <div class="form-group col-sm-3">
            <kez-input
              :label="'Heures estimées'"
              v-model="estimatedHours"
              type="number"
              validate="required"
            />
          </div>
          <div class="form-group col-sm-3">
            <kez-input :label="'Nom'" v-model="name" validate="required"/>
          </div>
          <div class="form-group col-sm-2">
            <div class="addBtn">
              <button
                v-if="isAdd"
                type="submit"
                class="btn btn-action btn-md"
                @click="add(regularTask)"
              >Ajouter</button>
              <button
                v-if="!isAdd"
                type="submit"
                class="btn btn-action btn-md"
                @click="completeEdit()"
              >Modifier</button>
              <button
                v-if="!isAdd"
                type="submit"
                class="btn btn-action btn-md"
                @click="cancel()"
              >Cancel</button>
            </div>
          </div>
        </div>
        <div>
          <div class="form-row">
            <div class="form-group col-sm-3">
              <kez-input
                :label="'Temps minimum'"
                v-model="timeMin"
                :disabled="true"
                validate="required"
              />
            </div>
            <div class="form-group col-sm-3">
              <kez-input
                :label="'Temps maximum'"
                v-model="timeMax"
                :disabled="true"
                validate="required"
              />
            </div>
          </div>
        </div>
      </div>
      <hr class="line">
    </section>
    <div class="form-row">
      <div class="search-wrapper form-group col-sm-8 headerTask">
        <h3>Liste des tâches régulières</h3>
      </div>
      <!-- SEARCH -->
      <div class="search-wrapper form-group col-sm-4 headerTask">
        <input type="search" v-model="search" placeholder="Nom" id="searchField">
        <button type="submit" class="btn btn-action btn-sm" v-on:click="resetFields()">
          <i class="material-icons">cancel</i>
        </button>
      </div>
    </div>
    <!-- -->
    <table class="table table-striped mt-1">
      <thead>
        <tr>
          <th>Type</th>
          <th>Nom</th>
          <th>Heures estimées</th>
          <th>Temps minimum</th>
          <th>Temps maximum</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr :task="task" v-for="(task,index) in filteredList" v-bind:key="index">
          <td>
            <kez-select
              :noLabelDisplayed="true"
              :label="'Type'"
              v-model="task.typeGuid"
              :options="formattedRegularTaskTypes"
              validate="required"
              v-bind:disabled="task.disabled"
            />
          </td>
          <td>
            <input type="text" v-model="task.name" v-bind:disabled="task.disabled">
          </td>
          <td>
            <input
              type="number"
              v-model="task.estimatedHours"
              v-bind:disabled="task.disabled"
              @keyup="getTime(task)"
            >
          </td>
          <td width="10%">{{ task.timeMin }}</td>
          <td width="10%">{{ task.timeMax }}</td>
          <td>
            <div v-show="task.disabled" class="inline">
              <button type="submit" class="btn btn-action btn-sm" @click="edit(task)">
                <i class="material-icons">edit</i>
              </button>
              <button
                type="submit"
                class="btn btn-action btn-sm inline"
                @click="remove(task.regularTaskGuid)"
              >
                <i class="material-icons">delete</i>
              </button>
            </div>

            <div v-show="!task.disabled" class="inline">
              <button type="submit" class="btn btn-action btn-sm inline" @click="cancel(task)">
                <i class="material-icons">cancel</i>
              </button>
              
              <button type="submit" class="btn btn-action btn-sm inline" @click="save(task)">
                <i class="material-icons">done</i>
              </button>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
    <kez-confirm-modal
      v-model="openModalDelete"
      :title="'Supprimer une tâche'"
      :message="'Êtes-vous sur de vouloir supprimer cette tâche?'"
      @confirm="deleteTask()"
    />
  </div>
</template>
<script>
import { mapState, mapGetters } from "vuex";
import KezInput from "@/components/_forms/KezInput";
import KezSelectNoLabel from "@/components/_forms/KezSelectNoLabel";
import KezSelect from "@/components/_forms/KezSelect";
import KezConfirmModal from "@/components/_modals/KezConfirmModal";
import Search from "@/components/search/Search";

export default {
  components: {
    KezInput,
    KezConfirmModal,
    KezSelectNoLabel,
    KezSelect,
    Search
  },
  data() {
    return {
      isAdd: true,
      selectedTask: null,
      openModalDelete: false,
      isEdit: false,
      show: false,
      search: "",
      name: "",
      timeMin: "",
      timeMax: "",
      estimatedHours: ""
    };
  },
  computed: {
    filteredList() {
      return this.regularTasks.filter(task => {
        if (task.isActive == true && task.name.toLowerCase().includes(this.search.toLowerCase() )) {
          return task
        }
        return null;
      });
    },
    estimatedHours() {
      return this.regularTask.estimatedHours;
    },
    ...mapState("regularTasks", ["regularTasks", "regularTask"]),
    ...mapGetters("regularTaskTypes", [
      "formattedRegularTaskTypes",
      "formattedType"
    ]),
    ...mapGetters("parameters", ["calculMin", "calculMax"])
  },
  watch: {
    estimatedHours: {
      handler(newVal) {
        if (newVal && newVal != "") {
          this.timeMin = this.calculMin(newVal);
          this.timeMax = this.calculMax(newVal);
        } else{
          this.timeMin = "";
          this.timeMax = "";
        }
      }
    }
  },
  mounted() {
    this.$store.dispatch("regularTasks/getList");
    this.$store.dispatch("regularTaskTypes/getList");
  },
  methods: {
    add(task) {
      this.isEdit = true;
      const newTask = task;
      if (
        this.regularTask.typeGuid != null &&
        this.name != null &&
        this.estimatedHours != null
      ) {
        newTask.name = this.name;
        newTask.estimatedHours = this.estimatedHours;
        this.timeMin = this.calculMin(this.estimatedHours);
        this.timeMax = this.calculMax(this.estimatedHours);
        newTask.timeMin = this.timeMin;
        newTask.timeMax = this.timeMax;
        this.$store.dispatch("regularTasks/save", { regularTask: newTask });
              this.name = "";
      this.estimatedHours = "";
      this.timeMin = "";
      this.timeMax = "";
      }
    },
    deleteTask() {
      this.$store.dispatch("regularTasks/delete", this.selectedTask);
    },
    remove(task) {
      this.selectedTask = task;
      this.openModalDelete = true;
    },
    edit(task) {
      if (task.disabled == undefined) {
        task.disabled = true;
      } else {
        task.disabled = task.disabled == true ? false : true;
      }
      task.oldValue = {
        typeGuid: task.typeGuid,
        estimatedHours: task.estimatedHours,
        timeMin: task.timeMin,
        timeMax: task.timeMax,
        name: task.name
      };
      this.task;
      //this.$store.dispatch("regularTasks/get", task);
      //this.isAdd = false;
    },
    cancel(task) {
      task.disabled = true;
      task.typeGuid = task.oldValue.typeGuid;
      task.estimatedHours = task.oldValue.estimatedHours;
      task.timeMin = task.oldValue.timeMin;
      task.timeMax = task.oldValue.timeMax;
      task.name = task.oldValue.name;

      //this.$store.commit("regularTasks/regularTask", {});
      //this.isAdd = true;
    },
    save(task) {
      this.isEdit = true;
      const newTask = task;
      this.$store.dispatch("regularTasks/save", { regularTask: newTask });
    },
    completeEdit(task) {
      this.$store.dispatch("regularTasks/save", {
        regularTask: task
      });
      this.isAdd = true;
    },
    getTime(task) {
      task.timeMin = this.calculMin(task.estimatedHours);
      task.timeMax = this.calculMax(task.estimatedHours);
    },
    resetFields() {
      this.search = "";
    }
  }
};
</script>

<style>
#gestion {
  display: inline-block;
}
#hidder {
  display: inline;
  background-color: rgb(151, 151, 151);
}
.addBtn {
  margin-top: 38px;
}
.headerTask {
  margin-top: 30px;
}
.line {
  margin: 0px;
}
.inline {
  display: block;
}
.inline button {
  float: right;
  margin-right: 10px;
}
</style>
